export default class Project {
    constructor() {
        if (document.querySelector('#project #main-image')) {
            // this.animation();
        }
    }

    animation() {
        const section = document.querySelector('#project #main-image');
        const curtainLeft = document.querySelector('#project #main-image .curtain-left');
        const curtainRight = document.querySelector('#project #main-image .curtain-right');

        window.addEventListener('scroll', function (){
            const windowY = window.scrollY + window.innerHeight;
            const sectionOffset = section.getBoundingClientRect().top + section.ownerDocument.defaultView.pageYOffset;
            const offsetToAction = (sectionOffset + section.offsetHeight - curtainLeft.clientWidth);

            if(windowY > offsetToAction){
                const position = windowY - offsetToAction;
                if(position > 0){
                    curtainLeft.style.left = '-' + position + 'px';
                    curtainRight.style.right = '-' + position + 'px';
                }
            }
        })
    }
}
